import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "html-editor" }

import getDefaultEditorConfig from "@plugins/tinymce-editor/defaultEditorConfig";
import { smartSnippetPlugin } from "@plugins/tinymce-editor/smartsnippets.js";
import tinymceEditor from "@tinymce/tinymce-vue";
import { Editor, RawEditorOptions } from "tinymce";
import { ref } from "vue";
import { watch } from "vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HTMLEditor',
  props: {
    value: {},
    id: {},
    rows: {},
    additionalConfig: {},
    disabled: { type: Boolean },
    hasSmartSnippets: { type: Boolean },
    articleId: {},
    dataCy: {}
  },
  emits: ["input", "init", "change", "blur", "focus", "fullscreen-state-changed", "editor-input"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;




const localValue = computed({
  get: () => {
    return props.value;
  },
  set: (nv) => {
    emits("input", nv);
  }
});

const localEditor = ref<Editor | null>(null);

watch(
  () => props.value,
  (nv) => {
    if (localEditor.value?.getContent() != nv) localEditor.value?.setContent(nv ?? "");
  },
  { immediate: true }
);

const getTinymceConfig = () => {
  const baseConfig = getDefaultEditorConfig();
  baseConfig.article_id = props.articleId;
  baseConfig.setup = (editor) => {
    localEditor.value = editor;
    //@ts-ignore
    if (tinymce.PluginManager) tinymce.PluginManager.add("smartsnippets", smartSnippetPlugin);
    editor.on("init", function (e) {
      editor.setContent(localValue.value ?? "");
      emits("change", e);
    });
    editor.on("input", function (e) {
      localValue.value = editor.getContent();
      emits("editor-input", e);
    });
    editor.on("change", function (e) {
      localValue.value = editor.getContent();
      emits("change", e);
    });
    editor.on("blur", function (e) {
      emits("blur", e);
    });
    editor.on("focus", function (e) {
      emits("focus", e);
    });
    editor.on("FullscreenStateChanged", function (e) {
      emits("fullscreen-state-changed", e);
    });
  };
  return Object.assign(baseConfig, props.additionalConfig);
};

const getEditor = () => {
  return localEditor.value;
};

__expose({ getEditor });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(tinymceEditor), {
      init: getTinymceConfig(),
      disabled: _ctx.disabled,
      id: _ctx.id,
      rows: _ctx.rows,
      "data-cy": _ctx.dataCy
    }, null, 8, ["init", "disabled", "id", "rows", "data-cy"])
  ]))
}
}

})